exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-052a92e8] .filter-field {\n  display: inline-block;\n  width: 200px;\n  margin-right: 20px;\n}\n", ""]);

// exports
